import axios from './axios';

export const getPhylloSdkToken = () =>
    axios<BULLZ.PhylloSdkTokenResponseApiResponse>({
        url: '/phyllo/sdk/token',
        method: 'GET'
    });
